/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Profile_TitleInputs */



/**
* | output |
* | --- |
* | "Select Profile" |
*
* @param {Editor_Select_Profile_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_title = /** @type {((inputs?: Editor_Select_Profile_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le profil")
	if (locale === "de") return /** @type {LocalizedString} */ ("Profil auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona profilo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите профиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar perfil")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择个人资料")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロフィールを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोफ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar perfil")
	return /** @type {LocalizedString} */ ("Select Profile")
});